import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { useSelector } from 'react-redux'
import PDF from './PDF'

const PDFContainer = (props) => {
  const blockDownload = useSelector(state => {
    return get(state, 'campaign.items.block_download', false)
  })

  return (
    <PDF
      url={props.url}
      blockDownload={blockDownload} />
  )
}

PDFContainer.propTypes = {
  url: PropTypes.string.isRequired
}

export default PDFContainer
